import React from "react";
import MyinvitationsEmptyImg from "../../../images/new-images/MyinvitationsEmptyImg.png";

const MyinvitationsEmpty = (props) => {
  return (
    <React.Fragment>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img className="MyinvitationsEmptyImg" src={MyinvitationsEmptyImg} />
      </div>
      <h6 className="You-do-not-have-any-invitations-yet">{props.emptyText}</h6>
    </React.Fragment>
  );
};

export default MyinvitationsEmpty;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Invitations-Empty.jsx